import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const ModalHeader = styled('div')`
    background-color: rgba(255, 255, 255, 0.06);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-bottom: 1px solid #4a4a4a;
    flex-shrink: 0;
`;

export const ModalTitle = styled(Typography)`
    font-weight: 500;
    font-size: ${({ compact }) => (compact ? '16px' : '20px')};
    color: #dcc6b7;
`;

export const ModalBody = styled('div')`
    background-color: #212121;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #4a4a4a #212121;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #212121;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #4a4a4a;
        border-radius: 3px;
    }
`;

export const KvCard = styled('div')`
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 12px;
    padding: ${({ compact }) => (compact ? '16px 18px 18px' : '12px 18px')};
`;

export const KvCardHeader = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 133px;
`;

export const KvCardTitle = styled(Typography)`
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
`;

export const KvCardDivider = styled('div')`
    height: 1px;
    background-color: #4a4a4a;
    margin: 12px 0 14px;
`;

export const KvGrid = styled('div')`
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
`;

export const KvItem = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 0;
    min-width: 150px;
`;

export const KvLabel = styled(Typography)`
    font-weight: 400;
    font-size: 13px;
    color: #9e9e9e;
`;

export const KvValue = styled(Typography)`
    font-weight: 500;
    font-size: 17px;
    color: ${({ negative }) => (negative ? '#e26257' : '#ffffff')};
`;

export const InlineKv = styled('div')`
    display: flex;
    align-items: baseline;
    gap: 4px;
`;
